import { render, staticRenderFns } from "./RecoverResourceModal.vue?vue&type=template&id=6d8ead5a&scoped=true&"
import script from "./RecoverResourceModal.vue?vue&type=script&lang=js&"
export * from "./RecoverResourceModal.vue?vue&type=script&lang=js&"
import style0 from "./RecoverResourceModal.vue?vue&type=style&index=0&id=6d8ead5a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8ead5a",
  null
  
)

export default component.exports